
import Bluetooth2 from "../../../assets/outline/Bluetooth2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Bluetooth2Icon({ className, dataTestid = "Bluetooth2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bluetooth2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
